<template>
  <div :class="flag ? 'header' : 'header header_act'">
    <div class="head">
      <div class="head-left">
        <img v-if="flag" src="@/assets/index/logo.png" alt />
        <img v-else src="@/assets/index/logo_act.png" alt />
      </div>
      <div class="head-center">
        <ul class="list">
          <li
            v-for="(item, index) in menuList"
            :key="item.name"
            @mouseenter="showDropdown(index)"
            @mouseleave="handleMouseLeave"
            :class="item.path === activeMenu ? 'item item-act' : 'item'"
          >
            <a
              class="item-text"
              @click="skip(item)"
              @focus="showDropdown(index)"
              @blur="handleTextBlur"
            >{{ item.meta.title }}</a>
            <div
              v-if="item.node && activeIndex === index"
              class="item-box"
              @focusin="clearHideTimer"
              @focusout="handleBoxBlur"
            >
              <ul class="li-item_one">
                <li
                  @click="skipSolutionDetail(dropdownItem)"
                  :class="solutionAct === dropdownIndex ? 'li-item_item li-item_item-act' : 'li-item_item'"
                  @mouseenter="getDetail(dropdownItem, dropdownIndex)"
                  v-for="(dropdownItem, dropdownIndex) in item.node"
                  :key="dropdownIndex"
                >
                  <span class="item-text-item">{{ dropdownItem.name }}</span>
                </li>
              </ul>
              <div class="detail" v-if="detail.length !== 0 && solutionAct !== -1">
                <ul class="li-item_two">
                  <li
                    @click="skipSolutionDetail(item)"
                    class="li-item_item"
                    v-for="(item, index) in detail"
                    :key="index"
                  >
                    <div class="list_item">{{ item.name }}</div>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="head-right">
        <div v-if="!userInfo" class="btn">
          <div class="btn-text" @click="skip({path: '/login'})">登录/注册</div>
          <img src="@/assets/index/login_arrow.png" alt />
        </div>
        <div v-else class="user-info" @click="skip({path: '/personal'})">
          <img
            :src="userInfo.head_image || '@/assets/index/default-avatar.png'"
            alt="用户头像"
            class="user-avatar"
          />
          <div class="user">
            <span class="user-name">{{ userInfo.username || '用户' }}</span>
            <span class="close" @click.stop="dialogVisible = true">退出登录</span>
          </div>
        </div>
      </div>
    </div>
    <el-dialog v-model="dialogVisible" title width="500" :before-close="handleClose">
      <span>确定要退出登录吗</span>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="closeLogin">确认</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import router from '@/router'
import { ref, onMounted, onUnmounted, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { loginOut } from '@/api/login'
import { ElMessageBox, ElMessage } from 'element-plus'

const store = useStore()

// 从store获取解决方案列表
const solutionList = computed(() => store.getters.getSolutionList)

let menuList = ref([
  {
    path: "/",
    name: "index",
    meta: { title: "首页" },
  },
  {
    path: "/solution",
    name: "solution",
    meta: { title: "应急场景&解决方案" },
    node: []
  },
  {
    path: "/shopping",
    name: "shopping",
    meta: { title: "精品商城" },
  },
  {
    path: "/aboutUs",
    name: "aboutUs",
    meta: { title: "关于我们" },
  },
])

// 修改3：定义默认数据为常量
const defaultSolutionData = [
  {
    path: "/",
    name: "",
    meta: { title: "家庭应急" },
    children: [
      { path: "/", name: "", meta: { title: "溺水救援解决方案" } },
      { path: "/", name: "", meta: { title: "24小时便利售货柜" } },
      // 其他子项...
    ]
  },
]

const dialogVisible = ref(false)

const handleClose = (done) => {
  ElMessageBox.confirm('Are you sure to close this dialog?')
    .then(() => {
      done()
    })
    .catch(() => {
      // catch error
    })
}

function show (item) {
  console.log(item, "item")
}

// 添加用户信息响应式变量
let userInfo = ref(null)

let unMenuList = ['/shopping/list', '/shopping/detail']

//高亮路由
let activeMenu = computed(() => store.getters.getActiveMenu)

let activeIndex = computed(() => store.getters.getActiveIndex)

let detail = ref([])

// 高亮开关
let flag = ref(true)

let solutionAct = ref(-1)

// 添加隐藏定时器变量
let hideTimer = null

// 从本地存储获取用户信息的函数
function getUserInfoFromLocal () {
  try {
    const userData = localStorage.getItem('jishiyu-userInfo')
    if (userData) {
      userInfo.value = JSON.parse(userData)
    }
  } catch (error) {
    console.error('获取本地用户信息失败:', error)
    userInfo.value = null
  }
}

// 跳转
function skip (item) {
  store.commit('SET_ACTIVE_MENU', item.path)
  router.push(item.path)
}

function skipSolutionDetail (item) {
  window.scrollTo({ top: 0, behavior: 'smooth' });
  store.commit('SET_ACTIVE_MENU', '/solution')
  router.push({ path: '/solutionFin', query: { id: item.id, pid: item.pid } })
}

function showDropdown (index) {
  clearHideTimer() // 清除之前的定时器
  store.commit('SET_ACTIVE_INDEX', index)
}

// 处理文本失去焦点
function handleTextBlur () {
  // 设置延迟隐藏，给用户时间移到下拉框
  hideTimer = setTimeout(() => {
    store.commit('SET_ACTIVE_INDEX', -1)
  }, 200)
}

// 处理下拉框失去焦点
function handleBoxBlur () {
  // 设置延迟隐藏，考虑嵌套元素的焦点切换
  hideTimer = setTimeout(() => {
    store.commit('SET_ACTIVE_INDEX', -1)
  }, 200)
}

// 清除隐藏定时器
function clearHideTimer () {
  if (hideTimer) {
    clearTimeout(hideTimer)
    hideTimer = null
  }
}

// 处理鼠标离开
function handleMouseLeave () {
  // 使用延迟隐藏处理
  hideTimer = setTimeout(() => {
    store.commit('SET_ACTIVE_INDEX', -1)
  }, 200)
}

function getDetail (item, index) {
  if (!item) {
    detail.value = []
    solutionAct.value = -1
  } else {
    detail.value = item.node
    solutionAct.value = index
  }
  
}

function leave () {
  store.commit('SET_ACTIVE_INDEX', -1)
}

// 滚动监听函数
function handleScroll () {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
  flag.value = scrollTop <= 100
}

function closeLogin () {
  loginOut().then(res => {
    if (res.code === 1) {
      dialogVisible.value = false
      // 清除本地存储用户信息
      localStorage.removeItem('jishiyu-userInfo')
      // 重置用户信息变量
      userInfo.value = null
      // 跳转到登录页或首页
      router.push('/login')
    }
  })

}

// 组件挂载时添加滚动监听
onMounted(() => {
  
  window.addEventListener('scroll', handleScroll)
  // 初始化时检查一次滚动位置
  handleScroll()
  // 从本地存储获取用户信息
  getUserInfoFromLocal()

  // 添加路由变化监听，每次路由变化时重新获取用户信息
  router.beforeEach(() => {
    getUserInfoFromLocal()
  })

  // 调用接口获取解决方案列表并存储到store
  store.dispatch('fetchSolutionList').then(() => {
    // 成功获取数据后更新menuList
    if (solutionList.value && solutionList.value.length > 0) {
      menuList.value[1].node = solutionList.value
    } else {
      menuList.value[1].node = defaultSolutionData
    }
  }).catch(error => {
    console.error('获取解决方案列表失败:', error)
    // 失败时使用默认数据
    menuList.value[1].node = defaultSolutionData
  })
})

// 修改5：添加watch监听，实时更新menuList
watch(solutionList, () => {
  if (solutionList.value && solutionList.value.length > 0) {
    menuList.value[1].node = solutionList.value
  }
}, { deep: true })

// 组件卸载时移除滚动监听
onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
});

</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  height: 1rem;
  background: rgba($color: #000000, $alpha: 0.2);
  border: .01rem solid rgba(37, 37, 37, 0.2);
  box-sizing: border-box;
  padding: 0rem 2.66rem;
  .head {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .head-left {
      img {
        width: 1.1rem;
        height: .5rem;
      }
    }

    .head-center {
      height: 100%;
      .list {
        width: 6rem;
        height: 100%;
        display: flex;
        list-style: none;
        text-align: center;
        justify-content: space-between;
        .item {
          position: relative;
          display: block;
          height: 100%;
          .item-text {
            cursor: pointer;
            font-weight: 400;
            font-size: .2rem;
            color: #6c7275;
            display: block;
            line-height: 1rem;
            outline: none;
          }
          .item-box {
            height: 3.38rem;
            background: #dd4530;
            box-shadow: rgba($color: #000000, $alpha: 0.1);
            position: absolute;
            border-radius: .05rem;
            top: 1.21rem;
            .li-item_one {
              height: 3.38rem;
              overflow: auto;
              scrollbar-width: none;
              -ms-overflow-style: none;
              overflow: auto;
              width: 2.13rem;
              margin-left: .13rem;
              list-style: none;
              .li-item_item {
                cursor: pointer;
                display: flex;
                align-items: center;
                height: .5rem;
                width: 2.5rem;
                border-radius: .25rem;
                .item-text-item {
                  font-weight: 400;
                  font-size: .15rem;
                  color: #ffffff;
                  margin-left: .1rem;
                }
              }
              .li-item_item-act {
                background: #ffffff;
                .item-text-item {
                  color: #ff3c00;
                }
              }
            }
            .li-item_one::-webkit-scrollbar {
              display: none;
            }
            .detail {
              width: 1.77rem;
              height: 3.38rem;
              overflow: hidden;
              background: #ffffff;
              position: absolute;
              top: 0rem;
              left: 1.98rem;
              .li-item_two {
                list-style: none;
                .li-item_item {
                  width: 1.77rem;
                  height: .5rem;
                  line-height: .5rem;
                  border-bottom: .01rem solid #e9e9e9;
                  display: -webkit-box; /* 弹性盒子模型 */
                  -webkit-box-orient: vertical; /* 垂直排列 */
                  -webkit-line-clamp: 3; /* 限制显示3行 */
                  overflow: hidden;
                }
              }
            }
            .detail {
              width: 1.77rem;
              height: 3.38rem;
              overflow: hidden;
              background: #ffffff;
              border-radius: .05rem;
              position: absolute;
              top: 0rem;
              left: 1.98rem;
              .li-item_two {
                height: 3.38rem;
                overflow: auto;
                scrollbar-width: none;
                -ms-overflow-style: none;
                overflow: auto;
                list-style: none;
                .li-item_item {
                  cursor: pointer;
                  // padding: 0px 14px;
                  // box-sizing: border-box;
                  font-size: .15rem;
                  width: 1.77rem;
                  height: .5rem;
                  line-height: .5rem;
                  border-bottom: .01rem solid #f9f9f9;
                  // border-bottom: none; /* 移除原始边框 */
  position: relative;
                }
                .li-item_two .li-item_item::after {
  content: '';
  position: absolute;
  left: 14px;
  right: 14px;
  bottom: 0;
  height: .01rem;
  background-color: #e9e9e9;
}
              }
            }
          }
        }
        .item-act {
          a {
            color: #ff3c00 !important;
          }
        }
      }
    }

    .head-right {
      display: flex;
      align-items: center;
      gap: .25rem;

      .btn {
        cursor: pointer;
        width: 2.01rem;
        height: .66rem;
        background: #dd4530;
        border-radius: 16.66rem;
        display: flex;
        align-items: center;
        justify-content: center;
        .btn-text {
          font-weight: 500;
          font-size: .24rem;
          color: #ffffff;
          margin-right: .14rem;
        }
        img {
          width: .11rem;
          height: .34rem;
        }
      }

      // 用户信息样式
      .user-info {
        display: flex;
        align-items: center;
        gap: .13rem;
        cursor: pointer;
        padding: .1rem .2rem;
        border-radius: .25rem;
        transition: background-color 0.3s;

        &:hover {
          background-color: rgba(255, 255, 255, 0.1);
        }

        .user-avatar {
          width: .5rem;
          height: .5rem;
          border-radius: 50%;
          object-fit: cover;
          border: .03rem solid rgba(255, 255, 255, 0.3);
        }

        .user {
          display: flex;
          flex-direction: column;
          .user-name {
            font-weight: 500;
            font-size: .17rem;
            color: #333333;
          }
          .close {
            font-weight: 500;
            font-size: .13rem;
            color: #999999;
          }
        }
      }
    }
  }
}
.header_act {
  background: #ffffff;
  .head {
    .head-center {
      .list {
        .item {
          a {
            color: #6c7275;
          }
        }
        .item-act {
          a {
            color: #ff3c00;
          }
        }
      }
    }
  }
}
</style>